module.exports = __webpack_public_path__ + "media/images/star-pattern-b50377ad84f2c319ac0c52417b183672.svg";